<template lang="pug">
api-form(
  :fields="fields"
  :method="signIn"
)
  template(#append-fields)
    v-hover(
      v-slot="{ hover}"
    )
      router-link(to="/forgot-password")
        p.caption.mb-4(
          :class="{ 'redesignPrimaryDarken--text': hover }"
        ) Забыли пароль?
    template(v-if="showCaptcha")
      captcha-field(
        v-model="captchaData"
        clearable
        is-column
        hide-details
        @initialized="onCaptchaInit"
      )
  template(#save-btn="{ attrs, invalid, loading }")
    app-button(
      v-bind="attrs"
      :loading="loading"
      :disabled="invalid"
      rounded
      block
    ) Войти
</template>

<script>
import CaptchaField from '@/components/inputs/CaptchaField.vue';
import PasswordInput from '@/components/user-redesign/inputs/PasswordInput.vue';
import AppTextInput from '@/components/user-redesign/inputs/AppTextInput.vue';

const CAPTCHA_FIELD_RESPONSE_KEY = 'captcha';

export default {
  name: 'CredentialsTab',
  components: {
    CaptchaField,
  },
  data() {
    return {
      showPassword: false,
      captchaData: {},
      captchaInstance: null,
      isCaptchaNeedToShow: false,
      fields: [
        {
          text: 'Имя пользователя',
          value: 'username',
          component: AppTextInput,
          rules: 'required|username',
          component_attrs: {
            'hide-details': false,
            placeholder: 'Логин или номер сертификата',
          },
        },
        {
          text: 'Пароль',
          value: 'password',
          rules: 'required|password',
          component: PasswordInput,
          component_attrs: {
            'hide-details': false,
          },
        },
      ],
    };
  },
  computed: {
    showCaptcha() {
      // on VCHT captcha requires always
      return this.$conf.isVcht || this.isCaptchaNeedToShow;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    onCaptchaInit(captcha) {
      this.captchaInstance = captcha;
    },
    reloadCaptcha() {
      this.captchaInstance.reloadCaptcha();
    },
    signIn({ data, obs }) {
      const payload = {
        ...data,
        captcha: this.captchaData,
      };

      return this.$rApi.auth.authUserWithCredentials({ data: payload, obs }).then(({ response, error }) => {
        if (error) {
          if (CAPTCHA_FIELD_RESPONSE_KEY in error.response.data.validation) {
            this.isCaptchaNeedToShow = true;
          }

          return { error };
        }

        this.$emit('auth', response);

        return { response };
      });
    },
  },
};
</script>
